import {FINAL_ROUND, ROUNDS_WITH_RUINS_INCREASED_INCOME} from "../../../configs/game";
import {getRoundLimit} from "../../checkIfFinalRound";
import {selectSharedGameState} from "../../../redux/reducers/sharedStateReducer/selectors";

/**
 * Доход руин растет в последних ROUNDS_WITH_RUINS_INCREASED_INCOME раундах
 * партии — по ее собственному лимиту раундов (gameState.finalRound), а не по
 * общему FINAL_ROUND: у локальной партии он свой (счетчик «Раунды»), у миссий
 * кампании и глав обучения тоже. Лимит для окна — getRuinsIncomeRoundLimit.
 */

/**
 * Первый раунд с увеличенным доходом руин или null, если его нет: партия без
 * лимита раундов (миссия с finalRound: null) последних раундов не имеет
 */
export const getRuinsIncreasedIncomeStartRound = (roundLimit) => {
  const limit = getRoundLimit(roundLimit);
  if (limit === null) {
    return null;
  }
  return Math.max(1, limit - ROUNDS_WITH_RUINS_INCREASED_INCOME + 1);
};

export const checkIfRoundWithIncreasedRuinsIncome = (round, roundLimit) => {
  const startRound = getRuinsIncreasedIncomeStartRound(roundLimit);
  return startRound !== null && round >= startRound;
};

/**
 * Лимит раундов, от которого партия отсчитывает окно дохода руин.
 *
 * Записи матчей проигрываются через редьюсеры, поэтому правило зависит от
 * записи: партии, начатые до перевода окна на лимит партии, считали его от
 * FINAL_ROUND, и их записи обязаны проигрываться так же — иначе очки (а
 * изредка и исход: досрочный конец по отрыву) разошлись бы с сыгранными.
 * Флаг isRuinsIncomeByRoundLimit ставит LOAD_STATE (см. loadState в
 * redux/actions); у старых записей его нет — только у них он false.
 */
export const getRuinsIncomeRoundLimit = (gameState) => (
  gameState?.isRuinsIncomeByRoundLimit === false ? FINAL_ROUND : getRoundLimit(gameState?.finalRound)
);

export const selectRuinsIncomeRoundLimit = (state) => getRuinsIncomeRoundLimit(selectSharedGameState(state));
